var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContainerGradient = function SvgContainerGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#containerGradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#containerGradient_svg__b)",
    fillRule: "evenodd",
    d: "m15.614.36 7.068 4.16A2.65 2.65 0 0 1 24 6.812v7.515c0 .945-.503 1.819-1.32 2.293l-.001.001-11.629 6.782-.002.002a2.65 2.65 0 0 1-2.66 0l-.003-.002-7.076-4.129A2.64 2.64 0 0 1 0 16.991V9.438c0-.456.118-.896.331-1.282l.005-.008.015-.028c.226-.393.553-.729.959-.965L12.963.358a2.63 2.63 0 0 1 2.647 0zm-1.517 1.941a.38.38 0 0 1 .378 0h.001l6.172 3.633-10.73 6.222a.4.4 0 0 1-.402 0L3.341 8.575zm-3.05 11.802 2.047-1.187v6.69l-2.25 1.313v-6.71q.104-.048.204-.106m4.297 4.192V11.61l2.281-1.323v6.676zm4.531-2.643 1.673-.976.002-.001a.4.4 0 0 0 .2-.348V7.895l-1.875 1.088zM2.443 17.33l6.15 3.589v-6.71a3 3 0 0 1-.206-.107l-6.137-3.56v6.448c0 .142.076.271.193.34",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "containerGradient_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 23.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "containerGradient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgContainerGradient;